import { initBirdie } from '@birdie-so/snippet';

import { getAppGlobals } from '~/components/AppGlobals/utils';

// Module-level variables to track initialization and previous values
let birdieInitialized = false;
let lastPublicationId: string | undefined;

interface BirdieLoaderProps {
  publication: {
    id: string;
  };
  isAdmin: boolean;
}

const BirdieLoader = ({ publication, isAdmin }: BirdieLoaderProps) => {
  const appGlobals = getAppGlobals();
  const birdieClientId = appGlobals.VITE_BIRDIE_CLIENT_ID;

  if (birdieClientId && isAdmin) {
    // Only initialize once across all component instances
    if (!birdieInitialized) {
      initBirdie({
        clientId: birdieClientId,
        metadata: {
          publication: {
            id: publication.id,
          },
        },
      });

      // Store initial values
      lastPublicationId = publication.id;
      birdieInitialized = true;
    } else {
      // Only update metadata if values have changed
      const hasPublicationChanged = lastPublicationId !== publication.id;

      if (hasPublicationChanged) {
        // Update Snippet metadata if available
        if ((window as any).birdie && typeof (window as any).birdie.metadata !== 'undefined') {
          (window as any).birdie.metadata = {
            publication: {
              id: publication.id,
            },
          };
        }

        // Update stored values
        lastPublicationId = publication.id;
      }
    }
  }

  return null;
};

export default BirdieLoader;
